import { NgModule } from '@angular/core';
import { GTMService, GTMServiceFactory } from '.';

@NgModule({
  providers: [
    {
      provide: GTMServiceFactory,
      useExisting: GTMService,
    },
  ],
})
export class GTMModule {}
